/**
 * Created by staffanrantzow on 01/11/16.
 */

import axios from 'axios';

import CouponEntity from './coupon-entity';

class CouponService {

  hydrate (coupon) {
    return new CouponEntity(
      coupon.attributes.discount_value
    );
  }

  getById (id, invoiceId) {
    let url = `backend://coupons/${id}`;
    if (invoiceId !== null) {
      url += `/${invoiceId}`;
    }
    return axios.get(url)
      .then((response) => {
        return this.hydrate(response.data.data);
      });
  }

}

export default new CouponService();



/** WEBPACK FOOTER **
 ** ./src/frilans-finans/coupons/coupon-service.js
 **/